export default "__VITE_ASSET__CMcnS2dA__"